<template>
  <div>
    <div class="card-header">
            <span class="title">
                DESCRIÇÃO COMERCIAL

                 <i
                   class="fa fa-info-circle info-icon"
                   data-html="true"
                   data-trigger="hover"
                   data-toggle="popover"
                   data-placement="bottom"
                   :data-content="infoData">
                </i>
            </span>
    </div>
    <div class="panel-body" data-step="6" data-intro="Clique para editar os outros campos caso necessário.">
      <div :class="hasErrorInProduct ? 'has-error' : ''" v-show="inArray('product_code')" class="form-group" data-step="5" :data-intro="tourProducts"
           data-position="top">
        <label for="selectProductCode">
          Código do Produto *
        </label>

        <div class="product-search-container">
          <v-select
            ref="product"
            id="selectProductCode"
            @search="fetchSearchedProducts"
            v-model="product"
            :clearable="false"
            :filterable="false"
            :options="listOfProducts"
            label="label">
            <span slot="no-options">Nenhum produto encontrado.</span>
          </v-select>

          <qr-bar-code-reader
            @codeResult="fetchSearchedProductsFromScanner"
            btn-class="qr-btn">
          </qr-bar-code-reader>
        </div>

        <span v-if="hasErrorInProduct && messageError"  class="help-block has-error">
          <strong>{{ messageError }}</strong>
        </span>

      </div>
      <div class="form-group" v-show="inArray('main_description')">
        <label for="text">
          Descrição Principal
        </label>
        <textarea class="form-control" :maxlength="setMaxLength()" rows="2" style="resize: none;"
                  v-on:focus="clearField('main_description')" v-model="mainDescription" :disabled="isMagazine()"></textarea>
      </div>

      <div class="form-group" v-show="inArray('brand') && inTemplate('brand')">
        <label for="text">
          Marca
        </label>
        <input type="text" v-model="brand" maxlength="255" class="form-control"/>
      </div>

      <div class="form-group" v-show="inArray('minor_description')">
        <label for="text">
          Descrição Secundária
        </label>
        <input type="text" class="form-control" v-on:focus="clearField('minor_description')"
               v-model="minorDescription" :disabled="isMagazine()"/>
      </div>

      <div class="form-group" v-show="inArray('main_description2')">
        <label for="text">
          Descrição Principal 2
        </label>
        <textarea class="form-control" :maxlength="setMaxLength()" rows="2" style="resize: none;"
                  v-on:focus="clearField('main_description2')" v-model="mainDescription2"></textarea>
      </div>

      <div class="form-group" v-show="inArray('main_description3')">
        <label for="text">
          Descrição Principal 3
        </label>
        <textarea class="form-control" :maxlength="setMaxLength()" rows="2" style="resize: none;"
                  v-on:focus="clearField('main_description3')" v-model="mainDescription3"></textarea>
      </div>

      <div class="form-group" v-show="inArray('minor_description2')">
        <label for="text">
          Descrição Secundária 2
        </label>
        <input type="text" class="form-control" v-on:focus="clearField('minor_description2')"
               v-model="minorDescription2"/>
      </div>

      <div class="form-group" v-show="inArray('minor_description3')">
        <label for="text">
          Descrição Secundária 3
        </label>
        <input type="text" class="form-control" v-on:focus="clearField('minor_description3')"
               v-model="minorDescription3"/>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <div class="form-group" v-show="inArray('sales_unit') || inTemplate('UNIDADE')">
            <label class="labels-filler" for="selectSaleUnit">
              Unidade de Venda
            </label>
            <v-select ref="unit"
                      @search="fetchSearchedUnits"
                      id="selectSaleUnit"
                      :clearable="false"
                      v-model="unitSelected"
                      :options="listOfUnits"
                      label="label">
              <template slot="option" slot-scope="option">
                <span>
                  {{ option.name }}
                </span>
                <i @click.prevent="deleteUnit(option)" class="fas fa-times text-danger float-right"></i>
              </template>
              <span slot="no-options">Nenhuma unidade encontrada.</span>
            </v-select>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6">
          <div class="form-group" v-show="inArray('departament')">
            <label class="labels-filler" for="selectDepartment">
              Departamento
            </label>
            <v-select
              ref="department"
              :disabled="isMagazine()"
              @search="fetchSearchedDepartments"
              id="selectDepartment"
              :clearable="false"
              v-model="departmentSelected"
              :options="listOfDepartments"
              label="label">
              <template slot="option" slot-scope="option">
                <span>
                  {{ option.name }}
                  <i @click.prevent="deleteDepartment(option)"
                     class="fa fa-times text-danger float-right"></i>
                </span>
              </template>
              <span slot="no-options">Nenhum departamento encontrado.</span>
            </v-select>
          </div>
        </div>
        <div v-show="isMagazine()" class="col-sm-12">
          <div class="form-group">
            <button class="btn btn-update-price" @click.prevent="updateProduct">
              Atualizar produto conforme API
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from './services/product_service';
import vSelect from 'vue-select';
export default {
  props: {
    'subDomain': String,
  },
  components: {
    vSelect,
  },
  data() {
    return {
      store: this.$store.state.product,
      posterStore: this.$store.state.poster,
      oldCode: '',
      product: undefined,
      canClearFields: true,
      hasErrorInProduct: false,
      messageError: null,
    };
  },
  computed: {
    brand: {
      get() {
        return this.$store.getters['poster/field']('brand');
      },
      set(brand) {
        this.$store.commit('poster/SET_BRAND', brand);
      },
    },
    insert_custom_qrcode: {
      get() {
        return this.$store.getters['poster/field']('insert_custom_qrcode');
      },
      set(value) {
        this.$store.commit('poster/SET_INSERT_CUSTOM_QR_CODE', value);
      },
    },
    infoData() {
      return '<div>' +
        '<p><strong>Código do Produto</strong> é o SKU – número/nome de identificação do produto. ' +
        'Você pode criar um novo ou <u>importar uma planilha de produtos</u>.</p>' +
        '<div>'
    },
    hasAnyProductField() {
      return this.inArray('product_code')
        || this.inArray('main_description')
        || this.inArray('minor_description')
        || this.inArray('main_description2')
        || this.inArray('minor_description2')
        || this.inArray('main_description3')
        || this.inArray('sales_unit')
        || this.inArray('departament');
    },
    tourProducts() {
      if (this.isMagazine()) {
        return 'Digite o código GEMCO ou o nome do produto e pressione enter para selecionar o produto.';
      }
      return 'Digite o código do produto. Clique ou aperte "ENTER" em cima do código desejado para criar ou puxar as informações já existentes do produto.';
    },
    listOfUnits: {
      get() {
        return this.store.units;
      },
      set(units) {
        this.$store.commit('product/SET_UNITS', units);
      }
    },
    updatePrice: {
      get() {
        return this.$store.getters['poster/getUpdatePrice'];
      },
      set(updatePrice) {
        this.$store.commit('poster/SET_UPDATE_PRICE', updatePrice);
      },
    },
    action() {
      return this.$store.state.action;
    },
    listOfDepartments: {
      get() {
        return this.store.departments;
      },
      set(departments) {
        this.$store.commit('product/SET_DEPARTMENTS', departments);
      }
    },
    listOfProducts() {
      return this.store.products;
    },
    productSelected: {
      get() {
        return this.$store.getters['poster/getSelectedProduct'];
      },
      set(productSelected) {
        this.$store.commit('poster/SET_PRODUCT', productSelected);
      },
    },
    unitSelected: {
      get() {
        return this.$store.getters['poster/getSelectedUnit'];
      },
      set(unitSelected) {
        this.$store.commit('poster/SET_UNIT', unitSelected);
      },
    },
    departmentSelected: {
      get() {
        return this.$store.getters['poster/getSelectedDepartment'];
      },
      set(departmentSelected) {
        this.$store.commit('poster/SET_DEPARTMENT', departmentSelected);
      },
    },
    mainDescription: {
      get() {
        return this.productSelected.main_description;
      },
      set: _.debounce(function (mainDescription) {
        this.$store.commit('poster/SET_MAIN_DESCRIPTION', mainDescription);
      }, 300),
    },
    mainDescription2: {
      get() {
        return this.productSelected.main_description2;
      },
      set: _.debounce(function (mainDescription2) {
        this.$store.commit('poster/SET_MAIN_DESCRIPTION2', mainDescription2);
      }, 300),
    },
    mainDescription3: {
      get() {
        return this.productSelected.main_description3;
      },
      set: _.debounce(function (mainDescription3) {
        this.$store.commit('poster/SET_MAIN_DESCRIPTION3', mainDescription3);
      }, 300),
    },
    minorDescription: {
      get() {
        return this.productSelected.minor_description;
      },
      set: _.debounce(function (minorDescription) {
        this.$store.commit('poster/SET_MINOR_DESCRIPTION', minorDescription);
      }, 300),
    },
    minorDescription2: {
      get() {
        return this.productSelected.minor_description2;
      },
      set: _.debounce(function (minorDescription2) {
        this.$store.commit('poster/SET_MINOR_DESCRIPTION2', minorDescription2);
      }, 300),
    },
    minorDescription3: {
      get() {
        return this.productSelected.minor_description3;
      },
      set: _.debounce(function (minorDescription3) {
        this.$store.commit('poster/SET_MINOR_DESCRIPTION3', minorDescription3);
      }, 300),
    },
    fields() {
      if (this.$store.state.selector.template) {
        return this.$store.state.selector.template.fields.map(function (field) {
          return field.poster_field.field_id;
        });
      }
    },
    template() {
      return this.$store.getters['selector/getTemplate'];
    },
    posterContent: {
      get() {
        if (typeof this.template != 'undefined') {
          return this.template.content;
        }
        if (typeof this.posterState != 'undefined') {
          return this.$store.getters['poster/field']('content');
        }
      },
      set(content) {
        if (content) {
          this.$store.commit('poster/SET_CONTENT', content);
        }
      },
    },
  },
  mounted() {
    this.canClearFields = false;
    this.fetchUnits();
    if (!this.isMagazine()) {
      this.fetchDepartments();
      this.fetchProducts();
    }
    this.oldCode = this.$store.state.poster.fields.product_code;
    this.$root.$on('clearFields', () => {
      this.product = this.productSelected;
      this.hasErrorInProduct = false;
      this.messageError = null;
    });
    this.$root.$on('preview_ready', () => {
      const integrationCode = this.productSelected
        ? this.productSelected.integration_code
        : '';
      this.searchProduct(integrationCode);
    });
    this.$root.$on('updateMagazineProduct', () => {
      this.updateProduct();
    });

    this.$root.$on('has-product-error', (payload) => {
      this.hasErrorInProduct = payload.hasError;
      this.messageError = payload.message;
    });

    this.canClearFields = false;
  },
  watch: {
    product(product) {
      if (this.canClearFields && this.isMagazine()) {
        this.$store.dispatch('clearFields');
        this.$store.commit('poster/SET_SELECTED_TYPE', ' ');
      }
      if (product === null) {
        product = {
          id: undefined,
          code: '',
          barcode: '',
          integration_code: '',
          main_description: '',
          minor_description: '',
          ibm_code: '',
        };
      }
      if (this.subDomain === 'magazineluiza') {
        const integrationCode = product
          ? product.integration_code
          : '';
        this.searchProduct(integrationCode);
      } else {
        this.productSelected = product;
      }

      this.hasErrorInProduct = false;
      this.messageError = null;
      this.canClearFields = true;
    },
    productSelected(productSelected) {
      if (this.productSelected.code !== ' ' && this.productSelected.code !== this.oldCode) {
        this.$store.commit('poster/SET_BAR_CODE', this.productSelected.barcode || this.productSelected.code);
        this.$store.commit('poster/SET_QR_CODE', this.productSelected.qr_code || this.productSelected.code);
        this.$store.commit('poster/SET_IBM_CODE', this.productSelected.ibm_code || this.productSelected.code);
        if (this.oldCode) {
          this.$store.commit('SET_ACTION', 'create');
        }
        this.oldCode = this.productSelected.code;
      }
    },
    mainDescription(mainDescription) {
      if (this.isMagazine()) {
        if (mainDescription && mainDescription.length > 32) {
          this.mainDescription = mainDescription.slice(0, 32);
        }
      }
    },
  },
  methods: {
    clearForm() {
      this.$store.dispatch('clearFields');
      this.$store.commit('poster/SET_SELECTED_TYPE', ' ');
      let theme = this.$store.state.selector.theme;
      this.$store.commit('selector/SET_THEME', theme);
      this.$root.$emit('clearFields');
    },
    deleteUnit(unit) {
      if (_.get(unit, 'id')) {
        axios.delete('/online/units/' + unit.id).then((response) => {
          if (response.data.type == 'success') {
            this.unitSelected = {id: undefined, name: ' ', label: ''};
            this.listOfUnits = this.listOfUnits.filter((listUnit) => listUnit.id != unit.id);
            this.$root.throwFlashMessage('success', response.data.message);
          }
        }).catch(() => {
          this.$root.throwFlashMessage('danger', 'Houve um problema ao apagar unidade de venda');
        })
      }
    },
    deleteDepartment(department) {
      if (_.get(department, 'id')) {
        axios.delete('/online/departments/' + department.id).then((response) => {
          if (response.data.type == 'success') {
            this.departmentSelected = {id: undefined, name: ' ', label: ''};
            this.listOfDepartments = this.listOfDepartments.filter((depart) => depart.id != department.id);
            this.$root.throwFlashMessage('success', response.data.message);
          }
        }).catch(() => {
          this.$root.throwFlashMessage('danger', 'Houve um problema ao apagar departamento');
        })
      }
    },
    inTemplate(dataRole) {
      return (this.posterContent && _.includes(this.posterContent, dataRole));
    },
    inArray(data_role) {
      return (typeof this.fields != 'undefined' && this.fields.indexOf(data_role) > -1);
    },
    isMagazine() {
      return !!this.subDomain && this.subDomain == 'magazineluiza';
    },
    setMaxLength() {
      if (this.isMagazine()) {
        return 32;
      }
      return 255;
    },
    updateProduct() {
      this.updatePrice = true;
      const integrationCode = this.productSelected
        ? this.productSelected.integration_code
        : '';
      this.searchProduct(integrationCode);
    },
    searchProduct(codeToSearch) {
      if (codeToSearch && this.updatePrice) {
        let campaignId = this.$store.getters['selector/getCampaignId'];
        $('.loader-search').addClass('fa fa-spinner fa-spin');
        ProductService.fetchProduct(codeToSearch, campaignId).then((product) => {
          this.productSelected = product;
          this.departmentSelected = {
            id: -1,
            label: product.department,
            name: product.department,
          };
          this.unitSelected = {
            id: -1,
            label: product.unit,
            name: product.unit,
          },
            $('.loader-search').removeClass('fa fa-spinner fa-spin');
        }).catch((error) => {
          $('.loader-search').removeClass('fa fa-spinner fa-spin');
          this.$root.throwFlashMessage('danger', error.message);
        });
      }
    },
    clearField(field) {
      const value = this.$store.getters['poster/field'](field);
      if (!value || value == ' ') {
        this.$store.commit('poster/SET_FIELD_COMPOUND',
          {
            field: field,
            value: ' ',
          });
        setTimeout(() => {
          this.$store.commit('poster/SET_FIELD_COMPOUND',
            {
              field: field,
              value: '',
            });
        }, 100);
      }
    },
    emitShouldCreateEvent(value) {
      this.$root.$emit('posterShouldCreate');
    },
    fetchUnits() {
      ProductService.fetchUnits().then((units) => {
        this.$store.commit('product/SET_UNITS', units);
        return units;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    fetchDepartments() {
      ProductService.fetchDepartments().then((departments) => {
        this.$store.commit('product/SET_DEPARTMENTS', departments);
        return departments;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    fetchProducts() {
      ProductService.fetchProducts().then((products) => {
        const productInList = products.find(product => product.id === this.productSelected.id);
        if (productInList) {
          this.productSelected.barcode = productInList.barcode || productInList.code;
          products.push(this.productSelected);
        }
        this.product = this.productSelected;
        const data = {
          products: products,
          hasSubdomain: this.subDomain == 'magazineluiza',
        };
        this.$store.commit('product/SET_PRODUCTS', data);
        return products;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    fetchSearchedDepartments: _.debounce(function (query, loading) {
      loading(true);
      let departments = this.listOfDepartments;
      let lastDepartment = departments[0];
      if (lastDepartment && lastDepartment.id === -1) {
        departments.shift();
      }
      if (!(this.subDomain == 'magazineluiza') && this.departmentSelected.id == -1 && !!query)
        this.departmentSelected.id = -2;
      let indexDepartamentQuery = _.findIndex(departments, function (department) {
        return department.name.toLowerCase() == query.toLowerCase();
      });
      if (query && indexDepartamentQuery === -1) {
        departments.unshift({label: query + ' (criar novo)', name: query, id: -1});
      }
      this.$store.commit('product/SET_DEPARTMENTS', departments);
      loading(false);
      return departments;
    }, 300),
    fetchSearchedUnits: _.debounce(function (query, loading) {
      loading(true);
      let units = this.listOfUnits;
      let lastUnit = units[0];
      if (lastUnit && lastUnit.id === -1) {
        units.shift();
      }
      if (!(this.subDomain == 'magazineluiza') && this.unitSelected.id == -1 && !!query)
        this.unitSelected.id = -2;
      let indexUnitQuery = _.findIndex(units, function (unit) {
        return unit.name.toLowerCase() == query.toLowerCase();
      });
      if (query && indexUnitQuery === -1) {
        units.unshift({label: query + ' (criar nova)', name: query, id: -1});
      }
      this.$store.commit('product/SET_UNITS', units);
      loading(false);
      return units;
    }, 300),
    fetchSearchedProducts: _.debounce(function (query, loading) {
      loading(true);
      this.updatePrice = true;
      ProductService.fetchProducts(query).then((products) => {
        if (!(this.subDomain == 'magazineluiza') && this.product.id == -1 && !!query)
          this.product.id = -2;
        let indexProductQuery = _.findIndex(products, function (product) {
          return product.code.toLowerCase() == query.toLowerCase();
        });
        if (!!query && indexProductQuery === -1 && !(this.subDomain == 'magazineluiza')) {
          products.unshift({label: query + ' (criar novo)', code: query, id: -1});
        }
        const data = {
          products: products,
          hasSubdomain: this.subDomain == 'magazineluiza',
        };
        this.$store.commit('product/SET_PRODUCTS', data);
        this.$store.commit('SET_ACTION', 'create');
        loading(false);
        return products;
      }).catch((error) => {
        loading(false);
        this.$root.throwFlashMessage('danger', error.message);
      });
    }, 1000),
    fetchSearchedProductsFromScanner: _.debounce(function (query) {
      this.updatePrice = true;
      ProductService.fetchProducts(query).then((products) => {
        if (!(this.subDomain == 'magazineluiza') && this.product.id == -1 && !!query)
          this.product.id = -2;
        let indexProductQuery = _.findIndex(products, function (product) {
          return product.code.toLowerCase() == query.toLowerCase();
        });
        if (indexProductQuery != -1) {
          this.product = products[indexProductQuery];
        }
        if (!!query && indexProductQuery === -1 && !(this.subDomain == 'magazineluiza')) {
          products.unshift({label: query + ' (criar novo)', code: query, id: -1});
          this.product = products[0];
        }
        const data = {
          products: products,
          hasSubdomain: this.subDomain == 'magazineluiza',
        };
        this.$store.commit('product/SET_PRODUCTS', data);
        this.$store.commit('SET_ACTION', 'create');
        return products;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    }, 300),
  },
};
</script>

<style scoped>
.widget-head {
  border: 1px solid #3540512b;
  background: #D7E3E5;
  color: black;
  padding: 0 20px;
}
.panel-body {
  background-color: #fff;
  border: 1px solid #3540511f;
}
.btn-update-price {
  background-color: #e0e0e0;
  border: 1px solid #e0e0e0;
  margin-bottom: 10px;
  width: 100%;
  background-color: white;
}
.btn-update-price:hover {
  background-color: #f1f1f1;
}
.btn-update-price:active {
  background-color: #d6d6d6;
}
.product-search-container {
  display: grid;
  flex-direction: column;
  grid-template-columns: 85% 15%;
}
</style>
<style>
.v-select .dropdown-toggle {
  min-height: 32px !important;
}
.v-select .selected-tag {
  display: inline-table;
  min-height: 26px !important;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Product.vue